import { IGroupSettingListVM } from '../../models/response/IGroupSettingResponse';

const initialGroupSettingState: IGroupSettingListVM = {
  PagingDetails: {
    TotalRecords: 1,
    TotalPages: 1,
    CurrentPage: 1,
    PageSize: 10,
  },
  Trays: [],
};

export default initialGroupSettingState;
